import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { ImageWithLabel, ExternalLink } from "../components"
import classnames from "classnames"
import { useIntl } from "react-intl"
import { langId } from "../languages"

// image gallery is only use for querying images in src folder
// not for static images!!!

const BrWrapper = ({ children }) => {
  return (
    <>
      {children}
      <br />
    </>
  )
}

const ImageCompare = ({ imageArr = [], className, title, hasLabel }) => {
  const Images = useStaticQuery(graphql`
    query {
      allFile(
        filter: {
          relativeDirectory: { regex: "/^images/" }
          extension: { regex: "/(jpg)|(png)|(jpeg)/" }
        }
      ) {
        edges {
          node {
            ...fragmentsFluidImage
            relativePath
            relativeDirectory
          }
        }
      }
    }
  `)
  const queryImageMap = Images.allFile.edges
    .map(file => file.node)
    .reduce((acc, cur) => {
      return { ...acc, [cur.relativePath]: cur }
    }, {})
  const intl = useIntl()

  // console.log("ImageGallery children", children)
  console.log("!!!!!!", queryImageMap[imageArr[0].path])
  return (
    <div className="image-compare">
      {hasLabel && (
        <div className="image-compare__label">
          <div>{intl.formatMessage({ id: langId.PAST })}</div>
          <div>{intl.formatMessage({ id: langId.CURRENT })}</div>
        </div>
      )}
      <div className="image-compare__title">
        {title.href ? (
          <ExternalLink href={title.href}>{title.title}</ExternalLink>
        ) : (
          title.title
        )}
      </div>
      <div className="image-compare__content">
        {imageArr.map((img, index) => (
          <div key={index}>
            <div className="image-compare__content__img-title">
              {intl.formatMessage({ id: index ? langId.CURRENT : langId.PAST })}
            </div>
            <div className="image-compare__content__img">
              <ImageWithLabel
                fluidImage={queryImageMap[img.path].childImageSharp.fluid}
                imgAlt={img.imgAlt}
                imgTitle={img.imgTitle}
                label={img.label}
              ></ImageWithLabel>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ImageCompare
